// @flow

import pure from "./higher-order/pure";
import React from "react";
import yardsToFurlongs from "../yards-to-furlongs";

export default pure(function RaceOverview({ race }) {
  var parts = [];
  if (race.get("distance")) {
    parts.push(yardsToFurlongs(race.get("distance")));
  }
  if (race.get("surface")) {
    parts.push(race.get("surface"));
  }
  if (race.get("race_type")) {
    parts.push(race.get("race_type"));
  }
  if (parts.length === 0) {
    return null;
  }
  return (
    <span>
      {parts.join(", ")}
    </span>
  );
});
